import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admincontabilidad',
  templateUrl: './admincontabilidad.component.html',
  styleUrls: ['./admincontabilidad.component.scss']
})
export class AdmincontabilidadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admincontabilidad/admincontabilidad.component.ts